import { encrypty, decrypty } from './helpers';

export const removeUserFromStorage = (): void => {
  localStorage.removeItem('user_name');
  localStorage.removeItem('user_bp');
  localStorage.removeItem('cooper_token');
  localStorage.removeItem('user_data');
  localStorage.removeItem('user_id');
  localStorage.removeItem('user_role');
  localStorage.removeItem('user_type');
  localStorage.removeItem('user_permissions');
  localStorage.removeItem('user_mail');
};

export const getUserName = (): string | null => {
  const name = localStorage.getItem('user_name');

  if (!name) {
    return null;
  }

  return decrypty(name);
};

export const getUserBP = (): string | null => {
  const bp = localStorage.getItem('user_bp');

  if (!bp) {
    return null;
  }

  return decrypty(bp);
};

export const getAccessToken = (): string | null => {
  const token = localStorage.getItem('cooper_token');

  if (!token) {
    return null;
  }

  return decrypty(token);
};

export const getUserId = (): string | null => {
  const userId = localStorage.getItem('user_id');

  if (!userId) {
    return null;
  }

  return decrypty(userId);
};

export const getUserRole = (): string | null => {
  const role = localStorage.getItem('user_role');

  if (!role) {
    return null;
  }

  return decrypty(role);
};

export const getFullUserPermissions = (): {
  feature: string,
  category: string,
  type: string,
}[] => {
  const basicPerms = [{
    feature: 'basico',
    category: '*',
    type: 'BOTH',
  }];

  const permissions = localStorage.getItem('user_permissions');

  if (!permissions) {
    return basicPerms;
  }

  const decripted = decrypty(permissions);

  if (!decripted) {
    return basicPerms;
  }

  const parsed = JSON.parse(decripted);

  if (!parsed) {
    return basicPerms;
  }

  return basicPerms.concat(parsed);
};

export const getUserPermissions = (): Array<string> => {
  const permissions = getFullUserPermissions();
  const finalPermissions: Array<string> = [];

  if (permissions.length) {
    permissions.forEach((value) => {
      if (value && 'feature' in value) {
        finalPermissions.push(value.feature);
      }
    });
  }

  return finalPermissions;
};

export const getUserMail = (): string | null => {
  const mail = localStorage.getItem('user_mail');

  if (!mail) {
    return null;
  }

  return decrypty(mail);
};

export const getUserType = (): string | null => {
  const type = localStorage.getItem('user_type');

  if (!type) {
    return null;
  }

  return decrypty(type);
};

export const checkUserIsAuth = (): boolean => {
  const token = getAccessToken();
  return !!token;
};

export const setUserInfoOnLocalStorage = (data: any): void => {
  localStorage.setItem('user_data', encrypty(JSON.stringify(data)));
};

export const getUserInfoOnLocalStorage = (): any | null => {
  const data = localStorage.getItem('user_data');

  if (!data) {
    return null;
  }

  const decripted = decrypty(data);

  if (!decripted) {
    return null;
  }

  return JSON.parse(decripted);
};
